import { render, staticRenderFns } from "./ProductDetailForm.vue?vue&type=template&id=826529c2&scoped=true&"
import script from "./ProductDetailForm.vue?vue&type=script&lang=js&"
export * from "./ProductDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailForm.vue?vue&type=style&index=0&id=826529c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826529c2",
  null
  
)

export default component.exports